import React, { useState, useEffect } from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap, OverlayView, Marker } from 'react-google-maps';
import './StationsMap.scss';

import MapMarker from './MapMarker';
import {useSelector} from "react-redux";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const StationsMap = compose(
    withProps({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
        loadingElement: <div className='stationsMapLoadingElement' />,
        containerElement: <div className='stationsMapContainerElement' />,
        mapElement: <div className='stationsMapMapElement' />
    }),
    withScriptjs,
    withGoogleMap
) (props => {
    const { t } = useSelector(selector);
    const { zoom, center, markers } = props;
    const [displayInfo, setDisplayInfo] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState({});
    const [mapCenter, setMapCenter] = useState(center);
    const [mapZoom, setMapZoom] = useState(zoom);

    useEffect(() => {
        setMapCenter(center);
        setMapZoom(zoom);
    }, [center]);

    const renderStationInfo = () => (
        <div
            className='stationsMapMarkerSelected'
            onClick={() => {setDisplayInfo(false); setSelectedMarker({});}}
        >
            <div className='stationsMapMarkerSelectedTop'>{t.gettext('Temperature')}</div>
            <div className='stationsMapMarkerSelectedMiddle'>
                {selectedMarker.name}
            </div>
            <div className='stationsMapMarkerSelectedTop'>{t.gettext('Humidity')}</div>
            <div className='stationsMapMarkerSelectedMiddle'>
                {selectedMarker.city}
            </div>
            <div className='stationsMapMarkerSelectedBottom'>
                <MapMarker
                    color={selectedMarker.color}
                    width='17'
                    height='26'
                />
                <span>{selectedMarker.name}</span>
            </div>
        </div>
    );

    return (
        <GoogleMap
            zoom={mapZoom}
            center={mapCenter}
            options={{streetViewControl: false}}
        >
            {markers.length ?
                markers.map((marker, index) => {
                    return <Marker position={marker} key={index} />
                    // if (marker.id !== selectedMarker.id) {
                    //     return (
                    //         <OverlayView
                    //             key={index}
                    //             mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    //             position={marker}
                    //             children={
                    //                 <MapMarker
                    //                     color={marker.color}
                    //                     onClick={() => {
                    //                         setSelectedMarker(marker)
                    //                         setDisplayInfo(true);
                    //                     }}
                    //                 />
                    //             }
                    //         />
                    //     )
                    // }
                })
                : null
            }
            {displayInfo && Object.keys(selectedMarker).length !== 0 && selectedMarker.constructor === Object &&
                <OverlayView
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    position={{lat: selectedMarker.lat, lng: selectedMarker.lng}}
                    children={renderStationInfo(selectedMarker)}
                />
            }

        </GoogleMap>
    );}
);

export default StationsMap;
